export default __webpack_public_path__ + "static/media/nilByMouthIcon.5d56009e.svg";